import { useRef, useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export default function useCheckScrollToFooter() {
  const footerElement = useRef();
  const { pathname } = useLocation();

  const [isScrollToFooter, setIsScrollToFooter] = useState(false);

  function handleScroll() {
    if (!footerElement.current) {
      return;
    }

    setIsScrollToFooter(
      Math.round(
        footerElement.current.getBoundingClientRect().top -
          (window.innerHeight - footerElement.current.scrollHeight)
      ) <= footerElement.current.scrollHeight
    );
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [footerElement?.current, pathname]);

  const handleObserver = useCallback((entries) => {
    const target = entries[0];

    setIsScrollToFooter(target.isIntersecting);
  }, []);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver(handleObserver, option);
    if (footerElement.current) {
      observer.observe(footerElement.current);
    }
  }, [handleObserver, footerElement]);

  return {
    isScrollToFooter,
    footerElement,
  };
}
